// removed by extract-text-webpack-plugin
module.exports = {"badge":"Tz1C_cY9QXDLdZxUfVhDn","error":"_2eEBCgHTPa-UxPbwTYRIGu","critical":"_1Zo2kITenBYtMWoXWtw6JE","warning":"_1JAsCU2c-bBuuvGGL0kX75","needsAttention":"_1tjUi5J8Ot3ozO7M_62EV","info":"_1q9D9_gt4asM8FkFIUv2E6","default":"_1jJ_0oqmXekRSCdqZF_lS3","empty":"CpCx-au_Yk_V1VhNNZv3L"};


//////////////////
// WEBPACK FOOTER
// ./ui/Badge/index.module.css
// module id = 2414
// module chunks = 0